import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';
import GlobalProductsSettingsSidebarQuery from './src/ui/__generated__/GlobalProductsSettingsSidebarQuery.graphql';

export const nav4SidebarGlobalProductsSettingsEntryPoint: ReturnType<typeof createEntryPoint> =
	createEntryPoint({
		// sidebar is critical to rendering the initial view of a page
		root: JSResourceForUserVisible(
			() =>
				import(
					/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebars-settings-global-products" */ './src/ui/index'
				).then(({ SidebarContentForEntryPoint }) => SidebarContentForEntryPoint),
			{ includeInShellOnlySsrBundle: true },
		),
		getPreloadProps({ tenantContext: { cloudId, appEditions, isAdmin } }: EntryPointRouteParams) {
			return {
				queries: {
					nav4SidebarGlobalProductsSettings: {
						parameters: GlobalProductsSettingsSidebarQuery,
						variables: {
							cloudId,
							// We can skip the permission check when:
							// 1. The user is an admin (because admins can automatically manage custom onboarding configs), or
							// 2. Upsell is enabled (because upsell is only available to admins), or
							// 3. The main custom onboarding hub gate is disabled (because the custom onboarding feature won't be visible to anyone), or
							// 4. The delegated admin gate is disabled (because only admins would be able to view the feature)
							skipDelegatedAdminCheck:
								isAdmin ||
								(appEditions?.software !== 'PREMIUM_EDITION' &&
									fg('restrict-custom-onboarding-to-premium-tier')) ||
								!fg('jira-onboarding-hub-gate') ||
								!fg('jira-delegated-custom-onboarding'),
						},
						options: {
							fetchPolicy: 'store-and-network' as const,
						},
					},
				},
			};
		},
	});
